import URL from '@/api/URL'
import fetch from '@/api/fetch'


export function getManagerUserList(params) {
	return fetch.post(URL.getManagerUserList, params)
}
export function addManagerUserInfo(params) {
	return fetch.post(URL.addManagerUserInfo, params)
}
export function freezeManageUser(params) {
	return fetch.post(URL.freezeManageUser, params)
}
export function invalidManageUser(params) {
	return fetch.post(URL.invalidManageUser, params)
}
export function getManagerUserDetail(params) {
	return fetch.post(URL.getManagerUserDetail, params)
}
export function updateManageUserDetail(params) {
	return fetch.post(URL.updateManageUserDetail, params)
}
export function getRoleList(params) {
	return fetch.post(URL.getRoleList, params)
}
export function getRoleAuthorityList(params) {
	return fetch.post(URL.getRoleAuthorityList, params)
}
export function addRole(params) {
	return fetch.post(URL.addRole, params)
}

export function setRoleAuthority(params) {
	return fetch.post(URL.setRoleAuthority, params)
}

export function getNoticeList(params) {
	return fetch.post(URL.getNoticeList, params)
}
export function sendNotice(params) {
	return fetch.post(URL.sendNotice, params)
}


// WEBPACK FOOTER //
// ./src/api/modules/install.js